import { content } from '@content';

import {
  ContainerType,
  DateFormatOptions,
  FontCaseOptions,
  FontFamilyOptions,
  NumberFormatOptions,
  ButtonSettingsState,
  IdValueArray,
  DisplayOptions,
  BorderStyleOptions,
} from './ButtonSettings.props';
import { rgbToHex } from '@utils';

/**
 * ButtonSettings component utils
 * @returns {Function}
 */

export const getTitle = (type: ContainerType) => {
  switch (type) {
    case 'button':
      return content.button;
    case 'dataAttribute':
      return content.dataAttribute;
    default:
      return content.text;
  }
};

export const getOptionValueById = (
  options:
    | BorderStyleOptions
    | DisplayOptions
    | FontCaseOptions
    | FontFamilyOptions
    | NumberFormatOptions
    | DateFormatOptions,
  event: { target: { value: string } },
) => {
  return (options as IdValueArray).find((item: { id: string }) => item.id === event.target.value)?.value;
};

export const getOptionIdByValue = (
  options:
    | BorderStyleOptions
    | DisplayOptions
    | FontCaseOptions
    | FontFamilyOptions
    | NumberFormatOptions
    | DateFormatOptions,
  state: ButtonSettingsState | undefined,
  param: 'borderStyle' | 'display' | 'fontFamily' | 'fontCase' | 'tokenNumberFormat' | 'tokenDateFormat',
) => (options as IdValueArray).find((item: { value: string | undefined }) => item.value === state?.[param])?.id;

export const getHexColor = (color: string) => {
  if (color.includes('rgb')) {
    const numbers = color
      .replace('rgb(', '')
      .replace(')', '')
      .split(', ')
      .map((number) => Number(number));

    return rgbToHex(numbers[0], numbers[1], numbers[2]);
  }
  return color;
};
